import { render } from "./index.vue?vue&type=template&id=b74df046&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b74df046&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74df046"],['__file',"src/views/UrlAnexo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b74df046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b74df046', __exports__)) {
    console.log('reload')
    api.reload('b74df046', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b74df046&scoped=true", () => {
    console.log('re-render')
    api.rerender('b74df046', render)
  })

}


export default __exports__